import { render } from "./PreSignupDialog.vue?vue&type=template&id=4375bced&scoped=true"
import script from "./PreSignupDialog.vue?vue&type=script&lang=js"
export * from "./PreSignupDialog.vue?vue&type=script&lang=js"

import "./PreSignupDialog.vue?vue&type=style&index=0&id=4375bced&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4375bced"]])

export default __exports__